/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { BumpMarketV2 } from "../BumpMarketV2";

export class BumpMarketV2__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BumpMarketV2> {
    return super.deploy(overrides || {}) as Promise<BumpMarketV2>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BumpMarketV2 {
    return super.attach(address) as BumpMarketV2;
  }
  connect(signer: Signer): BumpMarketV2__factory {
    return super.connect(signer) as BumpMarketV2__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BumpMarketV2 {
    return new Contract(address, _abi, signerOrProvider) as BumpMarketV2;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newWhitelistAddress",
        type: "address",
      },
    ],
    name: "AddressAddedToWhitelist",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "removedWhitelistAddress",
        type: "address",
      },
    ],
    name: "AddressRemovedFromWhitelist",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "burnedYearnTokens",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountWithdrawn",
        type: "uint256",
      },
    ],
    name: "AmountWithdrawnFromYearn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ApprovedAmountToYearnVault",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "BumpPurchased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interestRate",
        type: "uint256",
      },
    ],
    name: "DepositMade",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "depositType",
        type: "uint256",
      },
    ],
    name: "DepositType",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DepositedAmountToYearnVault",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "PermittedForTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "rewardee",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "RewardIssued",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "SwappedBUSDCToBUMP",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TransferUsdc",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newSwapRateParameter1",
        type: "uint256",
      },
    ],
    name: "UpdateSwapRateParameter1",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newSwapRateParameter2",
        type: "uint256",
      },
    ],
    name: "UpdateSwapRateParameter2",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newTotalDeposits",
        type: "uint256",
      },
    ],
    name: "UpdateTotalDeposits",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBumpPurchaseAllocation",
        type: "uint256",
      },
    ],
    name: "UpdatedBumpPurchaseAllocation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBumpRewardAllocation",
        type: "uint256",
      },
    ],
    name: "UpdatedBumpRewardAllocation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "UpdatedFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newLevy",
        type: "uint256",
      },
    ],
    name: "UpdatedLevy",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newMaxBumpPercent",
        type: "uint256",
      },
    ],
    name: "UpdatedMaxBumpPercent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    name: "UpdatedSwapAllowedPeriod",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokensBurnt",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdcWithdrawn",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "WithdrawUsdc",
    type: "event",
  },
  {
    inputs: [],
    name: "BUMP_INITAL_PRICE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BUMP_REWARDS_BONUS_DRAG",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BUMP_REWARDS_BONUS_DRAG_DIVIDER",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BUMP_REWARDS_FORMULA_CONSTANT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SWAP_RATE_CONSTANT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "addAddressToWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "approveUSDCToYearnVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bumpPurchaseAllocation",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bumpRewardAllocation",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bumpTokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "busdcTokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentTVL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amountForBumpPurchase",
        type: "uint256",
      },
      {
        internalType: "enum BumpMarketV2.StableCoins",
        name: "_coin",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_depositType",
        type: "uint256",
      },
    ],
    name: "depositAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amountForBumpPurchase",
        type: "uint256",
      },
      {
        internalType: "enum BumpMarketV2.StableCoins",
        name: "_coin",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_depositType",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "depositAmountWithPermit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "depositDetails",
    outputs: [
      {
        internalType: "uint256",
        name: "interest",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "depositUSDCInYearnVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_totalDeposit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amountForPurchase",
        type: "uint256",
      },
    ],
    name: "estimateBumpRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_deposit",
        type: "uint256",
      },
    ],
    name: "estimateSwapRateBumpUsdc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum BumpMarketV2.StableCoins",
        name: "_coin",
        type: "uint8",
      },
    ],
    name: "getCurrentPrice",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSwapRateBumpUsdc",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getyUSDCIssuedToReserve",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "levy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxBumpPercent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pauseProtocol",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "removeAddressFromWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "swap",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "swapAllowedPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "swapRateParameter1",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "swapRateParameter2",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalDeposits",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalDepositsInit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpauseProtocol",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_bumpPurchaseAllocation",
        type: "uint256",
      },
    ],
    name: "updateBumpPurchaseAllocation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_bumpRewardAllocation",
        type: "uint256",
      },
    ],
    name: "updateBumpRewardAllocation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_fee",
        type: "uint256",
      },
    ],
    name: "updateFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_levy",
        type: "uint256",
      },
    ],
    name: "updateLevy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxBumpPercent",
        type: "uint256",
      },
    ],
    name: "updateMaxBumpPercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_end",
        type: "uint256",
      },
    ],
    name: "updateSwapAllowedPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_swapRateParameter1",
        type: "uint256",
      },
    ],
    name: "updateSwapRateParameter1",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_swapRateParameter2",
        type: "uint256",
      },
    ],
    name: "updateSwapRateParameter2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "usdcForBumpPurchase",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "usdcVault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawLiquidity",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawLiquidity",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdrawUSDCFromYearnVault",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdrawUSDCFromYearnVaultToAddress",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
